export const GET_FINYEAR_COMPANIES  = 'GET_FINYEAR_COMPANIES';
export const GET_FINYEAR_USERS  = 'GET_FINYEAR_USERS';
export const FINYEAR_COMPANY_REQUEST  = 'FINYEAR_COMPANY_REQUEST';
export const FINYEAR_COMPANY_REQUEST_FAILURE  = 'FINYEAR_COMPANY_REQUEST_FAILURE';